module.exports = __webpack_public_path__ + "img/bell.d84a0e5e.svg";